/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/housing': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M9.918 19.576v-5.294h4.4v5.294c0 .582.495 1.059 1.1 1.059h3.3c.605 0 1.1-.477 1.1-1.06v-7.41h1.87c.506 0 .748-.604.363-.922L12.855 3.27a1.14 1.14 0 00-1.474 0l-9.196 7.973c-.374.318-.143.921.363.921h1.87v7.412c0 .582.495 1.059 1.1 1.059h3.3c.605 0 1.1-.477 1.1-1.06z" _fill="#000" fill-rule="evenodd"/>'
  }
})
